import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLink } from '@fortawesome/free-solid-svg-icons';

interface ChainBadgeProps {
    chainId: string;
    chainName?: string | null;
    className?: string;
}

const ChainBadge: React.FC<ChainBadgeProps> = ({ chainId, chainName, className = '' }) => {
    return (
        <Link
            to={`/chains/${chainId}`}
            className={`inline-flex items-center gap-2 px-3 py-1.5 bg-sky/90 text-ink border-brutal border-ink shadow-brutal-sm rounded-sm text-xs font-bold uppercase tracking-wider hover:bg-sky-hover/90 hover:translate-x-[1px] hover:translate-y-[1px] hover:shadow-sm transition-all ${className}`}
        >
            <FontAwesomeIcon icon={faLink} className="text-xs" />
            <span>{chainName || 'View chain'}</span>
        </Link>
    );
};

export default ChainBadge;
